import { render, staticRenderFns } from "./box.vue?vue&type=template&id=05960d44"
import script from "./box.ts?vue&type=script&lang=ts&external"
export * from "./box.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports